<template>
  <transition name="fade">
    <div class="panel panel-primary">
      <div @click="show = !show" class="panel-heading">
        1 - DADOS INICIAIS
        <span class="pull-right">
          <i
            :class="show ? 'fa fa-arrow-down' : 'fa fa-arrow-right'"
            style="font-size: 1.5em"
            aria-hidden="true"
          ></i>
        </span>
      </div>
      <div v-if="show" class="panel-body" style="padding: 10px 20px">
        <div>
          <div class="row">
            <div class="col-md-4">
              <form-helper
                :inputVar="form.documentoCliente"
                :form="form"
                :label="isClienteFisico ? 'CPF' : 'CNPJ'"
                :mask="
                  isClienteFisico ? '###.###.###-##' : '##.###.###/####-##'
                "
                :disabled="true"
              />
            </div>
            <div class="col-md-4">
              <form-helper
                :inputVar="form.dataNasc"
                :form="form"
                label="Data de Nascimento/Fundação"
                validationType="date"
                placeholder="Digite"
                type="date"
                :disabled="true"
              />
            </div>
          </div>
          <div class="row">
            <div class="col-md-4">
              <form-helper
                :inputVar="form.telefone"
                :form="form"
                label="Telefone Celular"
                validationType="phone"
                maxlength="16"
                placeholder="(99) 99999-9999"
                :mask="['(##) #####-####']"
                :disabled="disableTelefone"
              />
            </div>
            <div class="col-md-4">
              <form-helper
                :inputVar="form.email"
                :form="form"
                validationType="email"
                label="Email"
                placeholder="Digite"
                :disabled="disableEmail"
              />
            </div>
            <div class="col-md-4">
              <form-helper
                :inputVar="form.cep"
                :disabled="currentStep > 1"
                :form="form"
                :mask="['#####-###']"
                label="CEP de Cobrança"
                placeholder="Digite"
              />
            </div>
          </div>

          <div class="row">
            <div class="col-md-3">
              <button
                v-if="!loading && currentStep == 1"
                aria-label="Próximo"
                style="margin-bottom: 0.5em"
                class="btn btn-primary"
                @click="nextStep()"
              >
                Próximo <i class="fa fa-chevron-right"></i>
              </button>

              <Loader
                v-if="loading"
                style="margin-top: 20px; margin-left: 20px"
              />
            </div>
          </div>
        </div>
      </div>
    </div>
  </transition>
</template>

<script>
import FormHelper from "@/components/partials/FormHelper.vue";
import SolAgoraService from "@/services/SolAgoraService";

const respostaPadraoErroGenerico =
  "Serviço indisponível, tente novamente mais tarde.";

export default {
  name: "SolAgoraStep1",
  props: {
    cliente: { type: Object, default: null },
    idProject: { type: String, default: "" },
    codigoPedido: { type: String, default: 0 },
    currentStep: { type: Number, default: 0 },
    token: { type: String, default: "" },
  },
  components: {
    FormHelper,
  },
  data() {
    return {
      form: {
        documentoCliente: new this.$formInput(true),
        dataNasc: new this.$formInput(true),
        telefone: new this.$formInput(true),
        email: new this.$formInput(true),
        cep: new this.$formInput(true),
        attemptSubmit: false,
        disableTelefone: true,
        disableEmail: true,
      },
      isClienteFisico: false,
      show: false,
      loading: false,
    };
  },
  mounted() {
    this.form.documentoCliente.value = this.cliente.CLI_CICCGC;
    this.form.dataNasc.value = this.cliente.CLI_DATANASCIMENTOFUNDACAO;
    this.form.telefone.value = this.cliente.CLI_FONE;
    this.form.email.value = this.cliente.CLI_EMAIL;
    this.form.cep.value = this.cliente.CLI_CEP;
    this.isClienteFisico = this.cliente.CLI_TIPO == "F";

    this.disableTelefone = this.cliente.CLI_FONE !== "";
    this.disableEmail = this.cliente.CLI_EMAIL !== "";
    this.show = true;
  },
  methods: {
    getSession: function () {
      return $.ajax({
        url: this.$apiUrl + "Session.svc/getsessions",
        dataType: "json",
        type: "GET",
        xhrFields: { withCredentials: true },
        success: (data) => {
          return data;
        },
      });
    },
    nextStep: async function () {
      this.loading = true;

      try {
        if (this.idProject) {
          this.$emit("updateConsumerData", {
            documentoCliente: this.form.documentoCliente.value,
            dataNasc: this.form.dataNasc.value,
            telefone: this.form.telefone.value,
            email: this.form.email.value,
            cep: this.form.cep.value,
            idProject: this.idProject,
          });

          this.$emit("next");
          return;
        }

        this.form.attemptSubmit = true;

        if (this.formErrors !== 0) return;

        let session = await this.getSession();
        const pev_codigo = this.codigoPedido.toString().split("-")[0];

        const res = await SolAgoraService.CreateProject({
          apiUrl: this.$apiUrl,
          token: this.token,
          name: this.cliente.CLI_NOME,
          document: this.form.documentoCliente.value,
          birthdate: this.form.dataNasc.value,
          phone: this.form.telefone.value,
          cep: this.form.cep.value,
          email: this.form.email.value,
          cnpj: session.DadosCliente.CliCiccgc,
          codigoPedido: pev_codigo,
        });

        if (!res) {
          swal({
            title: "Aviso",
            text: respostaPadraoErroGenerico,
            icon: "warning",
          });
          return;
        }

        if (res.data.Message) {
          swal({
            title: "Aviso",
            text: res.data.Message,
            icon: "warning",
          });
          return;
        }

        if (res.message) {
          swal({
            title: "Aviso",
            text: res.message,
            icon: "warning",
          });
          return;
        }

        this.$emit("updateConsumerData", {
          documentoCliente: this.form.documentoCliente.value,
          dataNasc: this.form.dataNasc.value,
          telefone: this.form.telefone.value,
          email: this.form.email.value,
          cep: this.form.cep.value,
          idProject: res.data.Id,
        });

        this.$emit("next");
      } finally {
        this.loading = false;
      }
    },
  },
  computed: {
    formErrors: function () {
      const errors = Object.keys(this.form).filter(
        (key) => this.form[key].validation && !this.form[key].validation.status
      );
      return errors.length;
    },
  },
};
</script>